import {
  Card,
  Grid,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  useTheme
} from '@mui/material';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface DonutStatItem {
  label: string;
  value: number;
  color?: string;
}

interface DonutStatCardProps {
  title: string;
  items: DonutStatItem[];
  totalLabel?: string;
  showChart?: boolean;
}

const ChartGraph = ({
  title,
  items,
  totalLabel = 'Total',
  showChart = true,
}: DonutStatCardProps) => {
  const theme = useTheme();

  const series = items.map(item => item.value);
  const labels = items.map(item => item.label);
  const total = series[0]
    const colors = items.map(item => item.color);


  const options: ApexOptions = {
    chart: { background: 'transparent' },
    labels,
    colors,
    plotOptions: {
      pie: {
        donut: {
          size: '75%',
          labels: {
            show: true,
            total: {
              show: true,
              label: totalLabel,
              color: theme.palette.text.primary,
              formatter: () => String(total)
            }
          }
        }
      }
    },
    legend: { show: false },
    stroke: { width: 0 },
    dataLabels: { enabled: false },
    theme: { mode: theme.palette.mode }
  };

  return (
    <Card sx={{ height: '100%' }}>
      <Box p={4}>
        <Typography variant="h4" fontWeight="bold" mb={3}>
          {title}
        </Typography>

        <Grid container alignItems="center">
          {showChart && (
            <Grid item xs={12} sm={7}>
              <Chart
                options={options}
                series={series}
                type="donut"
                height={260}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={showChart ? 5 : 12}>
            <List disablePadding>
              {items.map((item) => (
                <ListItem key={item.label} disableGutters>
                  <ListItemText
                    primary={item.label}
                    secondary={`${item.value}`}
                    primaryTypographyProps={{
                      variant: "h6",
                      fontWeight: 'bold'
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default ChartGraph;